import type { DeepRequired } from '../fixtures.types'

const providerStatement: DeepRequired<ProviderStatement> = {
  __typename: 'ProviderStatement',
  id: 'TEST_ID',
  provider_id: null,
  provider_name: null,
  club_name: null,
  period_id: null,
  total_amount: null,
  num_transactions: null,
  items_to_match: null,
  status: null,
}

export default providerStatement
